var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Transaction empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-empty"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(94.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-72",
    fill: "#87D5FA",
    x: 20,
    y: 49,
    width: 15,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-72-Copy",
    fill: "#87D5FA",
    x: 79,
    y: 49,
    width: 15,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-71",
    stroke: "#64808C",
    fill: "#FFFFFF",
    x: 10,
    y: 40,
    width: 94,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,0 L114,34.2632541 L114,41 L0,41 L0,34 L57,0 Z M56,33 C59.8659932,33 63,29.8659932 63,26 C63,22.1340068 59.8659932,19 56,19 C52.1340068,19 49,22.1340068 49,26 C49,29.8659932 52.1340068,33 56,33 Z",
    id: "Combined-Shape",
    stroke: "#64808C",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-71-Copy",
    stroke: "#64808C",
    fill: "#FFFFFF",
    x: 10,
    y: 98,
    width: 94,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-71-Copy-2",
    stroke: "#64808C",
    fill: "#FFFFFF",
    x: 0,
    y: 107,
    width: 114,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7026037,61 L66.5882196,61 L66.5882196,61.0351052 C65.5935665,62.5680413 65.0318884,63.3871552 64.9031686,63.4924714 L60.3921464,63.4924714 C61.0123419,64.2179831 61.4336005,65.1014559 61.6559347,66.1429163 L66.4653513,66.1429163 C66.5238603,66.1546181 66.5531144,66.1780213 66.5531144,66.2131268 C65.4765486,67.8279754 64.9265722,68.6353877 64.9031686,68.6353877 L61.778803,68.6353877 C61.7085922,69.4662156 61.3107369,70.4667047 60.5852252,71.6368849 C59.6256774,72.8187669 58.7070997,73.5852234 57.8294646,73.9362775 C56.1912123,74.7202982 54.6231943,75.1123027 53.1253637,75.1123027 L53.1253637,75.147408 C53.1253637,75.264426 56.5129846,79.2839347 63.288328,87.2060547 L58.812411,87.2060547 C52.2125947,79.5179707 48.912736,75.656434 48.912736,75.6213286 L48.912736,73.2868307 L48.9478412,73.1990677 C49.5329313,73.2809803 50.2174765,73.321936 51.0014972,73.321936 C54.6992667,73.321936 56.9986363,72.1225192 57.899675,69.7236498 C58.0400967,69.3725958 58.1103064,69.0098453 58.1103064,68.6353877 L48.0702105,68.6353877 C48.0234033,68.6353877 48,68.6119844 48,68.5651772 C49.1116712,66.9503285 49.6792001,66.1429163 49.7026037,66.1429163 L57.671491,66.1429163 L57.671491,66.1078111 C57.2151208,65.1833687 56.331648,64.4637187 55.0210461,63.9488394 C54.084902,63.6445925 53.2423849,63.4924714 52.4934695,63.4924714 L48.0351052,63.4924714 L48.0351052,63.4047083 C49.111671,61.8015614 49.6674983,61 49.7026037,61 Z",
    id: "`",
    fill: "#64808C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(203.000000, 210.000000) scale(1, -1) translate(-203.000000, -210.000000) translate(183.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#EB8181"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-16",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "17.1111111 10 17.1111111 27.8020024 10 21"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-16-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    transform: "translate(25.555556, 19.901001) scale(-1, -1) translate(-25.555556, -19.901001) ",
    points: "29.1111111 11 29.1111111 28.8020024 22 22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionEmptyState);
export default __webpack_public_path__ + "static/media/transactionEmptyState.6c4e87dd2f67edcda6fbc7b4b0e643f2.svg";
export { ForwardRef as ReactComponent };